// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__mS1MQ","inputGroup":"SearchBar_inputGroup__50H+K","formControl":"SearchBar_formControl__QpG0j","btn":"SearchBar_btn__TOGcR"};